import { render } from "./section-root.vue?vue&type=template&id=6c398e16&scoped=true"
import script from "./section-root.vue?vue&type=script&lang=js"
export * from "./section-root.vue?vue&type=script&lang=js"

import "./section-root.vue?vue&type=style&index=0&id=6c398e16&scoped=true&lang=css"

import exportComponent from "/home/mark/Dev/www/Portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c398e16"]])

export default __exports__